import {
  sendMessageAnamnesiApiCall,
  sendMessageApiCall,
  sendReminderSubscriptionApiCall,
  sendReminderToAllSubscriptionInASessionApiCall,
} from '@guryou/api-client-gql';

import { execute } from '../actions/actionWrapper';
import { Action, basicReducer } from '../core';

export const SEND_RESERVATION_REMINDER = { entity: 'SEND_RESERVATION_REMINDER', action: Action.CREATE };
export const SEND_SUBSCRIPTION_REMINDER = { entity: 'SEND_SUBSCRIPTION_REMINDER', action: Action.CREATE };
export const SEND_SESSION_SUBSCRIPTIONS_REMINDER = { entity: 'SEND_SESSION_SUBSCRIPTIONS_REMINDER', action: Action.CREATE };
export const SEND_ANAMNESI_REMINDER = { entity: 'SEND_ANAMNESI_REMINDER', action: Action.CREATE };

export const sendMessage = data => async dispatch => execute(dispatch, () => sendMessageApiCall(data), SEND_RESERVATION_REMINDER);

export const sendMessageAnamnesi = data => async dispatch => execute(dispatch, () => sendMessageAnamnesiApiCall(data), SEND_ANAMNESI_REMINDER);

export const sendReminderNotificationSubscription = subscriptionId => async dispatch =>
  execute(dispatch, () => sendReminderSubscriptionApiCall({ subscriptionId }), SEND_SUBSCRIPTION_REMINDER);

export const sendReminderNotificationSessionSubscriptions = sessionId => async dispatch =>
  execute(dispatch, () => sendReminderToAllSubscriptionInASessionApiCall({ sessionId }), SEND_SESSION_SUBSCRIPTIONS_REMINDER);

export const sqsMessageReducers = {
  sendReminder: basicReducer(SEND_RESERVATION_REMINDER),
  sendReminderAnamnesi: basicReducer(SEND_ANAMNESI_REMINDER),
  sendReminderSubscription: basicReducer(SEND_SUBSCRIPTION_REMINDER),
  sendReminderSessionSubscriptions: basicReducer(SEND_SESSION_SUBSCRIPTIONS_REMINDER),
};
